import AdminAboutUs from '@pages/admin/allPages/aboutUs'
import AdminPrivacyPolicy from '@pages/admin/allPages/privacyPolicy'
import AdminRefundPolicy from '@pages/admin/allPages/refundPolicy'
import AdminSeoSetting from '@pages/admin/allPages/seoSettings'
import AdminTermsAndCondition from '@pages/admin/allPages/termsAndCondition'
import AdminChangePasswordForm from '@pages/admin/auth/changePassword'
import BannerManagement from '@pages/admin/bannerManagement'
import AdminBookManagement from '@pages/admin/bookManagement'
import AdminBookManagementForm from '@pages/admin/bookManagement/form'
import AdminBookView from '@pages/admin/bookManagement/view'
import AdminCategoryManagement from '@pages/admin/categoryManagment'
import AdminDashboard from '@pages/admin/dashboard'
import AdminDriverManagement from '@pages/admin/deliveryManagement'
import AdminHelpSupport from '@pages/admin/helpSupport'
import AdminHelpSupportForm from '@pages/admin/helpSupport/form'
import AdminOrderManagement from '@pages/admin/orderManagement'
import AdminTransactionManagement from '@pages/admin/transaction'
import AdminUserManagement from '@pages/admin/userManagement'
import AdminUserView from '@pages/admin/userManagement/view/view'

const adminRoutes = [
  {
    Component: AdminDashboard,
    exact: true,
    path: 'dashboard',
  },
  {
    Component: AdminUserManagement,
    exact: true,
    path: 'user-managements',
  },
  {
    Component: AdminUserView,
    exact: true,
    path: 'user-managements/view/:id',
  },
  {
    Component: AdminUserView,
    exact: true,
    path: 'user-managements/view/:id/bookView/:bookId',
  },
  {
    Component: AdminBookManagement,
    exact: true,
    path: 'book-managements',
  },
  {
    Component: AdminBookManagementForm,
    exact: true,
    path: 'book-managements/add-book',
  },
  {
    Component: AdminBookView,
    exact: true,
    path: 'book-managements/view-book/:id',
  },
  {
    Component: AdminBookManagementForm,
    exact: true,
    path: 'book-managements/update-book/:id',
  },
  {
    Component: AdminAboutUs,
    exact: true,
    path: 'all-pages/about-us',
  },
  {
    Component: AdminTermsAndCondition,
    exact: true,
    path: 'all-pages/terms-and-condition',
  },
  {
    Component: AdminPrivacyPolicy,
    exact: true,
    path: 'all-pages/privacy-policy',
  },
  {
    Component: AdminRefundPolicy,
    exact: true,
    path: 'all-pages/refund-policy',
  },
  {
    Component: AdminHelpSupport,
    exact: true,
    path: 'help-support',
  },
  {
    Component: AdminChangePasswordForm,
    exact: true,
    path: 'change-password',
  },
  {
    Component: AdminCategoryManagement,
    exact: true,
    path: 'category-management',
  },
  {
    Component: AdminCategoryManagement,
    exact: true,
    path: 'category-management/:id',
  },
  {
    Component: BannerManagement,
    exact: true,
    path: 'banner-management',
  },
  {
    Component: BannerManagement,
    exact: true,
    path: 'banner-management/:id',
  },
  {
    Component: AdminDriverManagement,
    exact: true,
    path: 'delivery-management',
  },
  {
    Component: AdminSeoSetting,
    exact: true,
    path: 'all-pages/seo-settings',
  },
  {
    Component: AdminHelpSupport,
    exact: true,
    path: 'help-support',
  },
  {
    Component: AdminHelpSupportForm,
    exact: true,
    path: 'help-support/update/:type/:id',
  },
  {
    Component: AdminHelpSupportForm,
    exact: true,
    path: 'help-support/create/:type',
  },
  {
    Component: AdminOrderManagement,
    exact: true,
    path: 'order-management',
  },
  {
    Component: AdminTransactionManagement,
    exact: true,
    path: 'transaction-management',
  },
]
export default adminRoutes
